import EditHomeContainer from "../containers/EditHomeContainer";

const EditHomePage = () => {
  return (
    <EditHomeContainer />
  );
};

export default EditHomePage;
